// hooks/useGetPendingFeedbackJobs.ts
import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { IFeedbackJob } from "../types";

interface IGetDataProps {
  token?: string;
}

export const QUERY_KEY_FOR_PENDING_FEEDBACK_JOBS = "PendingFeedbackJobs";

const getPendingFeedbackJobs = async (
  props: IGetDataProps,
): Promise<IFeedbackJob[]> => {
  const url = `${END_POINT.BASE_URL}/v1/job/feedback/pending`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, config);
  return res.data.data || res.data;
};

export const useGetPendingFeedbackJobs = (props: IGetDataProps) => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_PENDING_FEEDBACK_JOBS, props],
    () =>
      getPendingFeedbackJobs({
        ...props,
        token,
      }),
    {
      onError: (err: any) => {
        console.error("Error fetching pending feedback jobs:", err);
      },
      onSuccess: (data) => {
        console.log("Pending feedback jobs fetched successfully:", data);
      },
      enabled: !!token,
    },
  );
  return queryData;
};
